var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurplePhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.248,
    height: 20.246,
    viewBox: "0 0 20.248 20.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "iconfinder_icon-ios7-telephone_211830",
    d: "M99.251,94.789c-.84-.863-3.227-2.479-4.791-2.479a1.7,1.7,0,0,0-.938.247,5.148,5.148,0,0,1-1.668.868c-.161,0-.334-.144-.713-.472l-.063-.058a19.958,19.958,0,0,1-1.685-1.576l-.1-.109c-.075-.075-.138-.144-.2-.207-.357-.368-.615-.633-1.53-1.668l-.04-.046c-.437-.495-.725-.817-.742-1.053s.184-.6.7-1.3a2.844,2.844,0,0,0,.075-3.077A14,14,0,0,0,85.694,81.2l-.058-.069a2.483,2.483,0,0,0-1.95-1.035,3.453,3.453,0,0,0-1.84.667c-.029.017-.058.04-.086.058a3.691,3.691,0,0,0-1.6,1.91c-.328,1.064-.546,2.444,1.024,5.314a25.681,25.681,0,0,0,4.544,6.16,27.452,27.452,0,0,0,4.486,3.819,10.429,10.429,0,0,0,5.36,2.318,3.911,3.911,0,0,0,3.7-1.72C100.769,96.82,100.148,95.715,99.251,94.789Z",
    transform: "translate(-79.927 -80.1)",
    fill: "#7E598B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurplePhone);
export default __webpack_public_path__ + "static/media/purple-phone.fd66b1479f79a2d2130521ee219f6c30.svg";
export { ForwardRef as ReactComponent };